import dayjs from "dayjs";

export const LoadboardTime = ({ stop }) => {
    if (!stop) {
        return <div className="text-cm-p-text-secondary">-</div>;
    }
    const earlyTime = stop.earlyTime ? dayjs(stop.earlyTime, "HH:mm").format("h:mm A") : null;
    let lateTime = stop.lateTime ? dayjs(stop.lateTime, "HH:mm").format("h:mm A") : null;

    if (earlyTime === lateTime) {
        lateTime = null;
    }

    return (
        <div className="text-cm-p-text-secondary">
            {earlyTime && lateTime ? `${earlyTime} - ${lateTime}` : earlyTime ? `${earlyTime}` : lateTime ? `${lateTime}` : "-"}
        </div>
    );
};
